import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";

export const LegalPage = ({ title, updated, testId, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid={testId}>
      <header className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/85 backdrop-blur-xl">
        <div className="mx-auto flex h-[72px] max-w-3xl items-center justify-between px-5 sm:px-8">
          <Link to="/" aria-label="Voltar para a página inicial" data-testid={`${testId}-logo`}>
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid={`${testId}-back-link`}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 transition-colors hover:text-brand"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar ao site
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-16 sm:px-8">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-petrol sm:text-4xl">
          {title}
        </h1>
        <p className="mt-3 font-mono text-[0.65rem] uppercase tracking-[0.22em] text-slate-400">
          Última atualização: {updated}
        </p>
        <div className="mt-12 space-y-10">{children}</div>
      </main>

      <footer className="border-t border-slate-200 py-8">
        <p className="mx-auto max-w-3xl px-5 text-xs text-slate-400 sm:px-8">
          © 2026 RESOLV — CNPJ 69.470.510/0001-29 — Rua Jomilda Camargo da Cunha, 293, Kobrasol,
          São José/SC
        </p>
      </footer>
    </div>
  );
};

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-display text-lg font-bold text-petrol">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">{children}</div>
  </section>
);
